import { useEffect } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import React, { useState } from 'react';
import InnerLoader from '../Shared/Loader/InnerLoader';
import { OverlayLoader } from '../Shared/Loader/OverlayLoader';
import { useTranslation } from 'react-i18next';

function DeleteProjectDialog({ toggleDialog, projectName, onDelete, organization }) {

    const [deleteName, setDeleteName] = useState("");
    const [deletingProject, setDeletingProject] = useState(false);
    const { t, i18n } = useTranslation([
        "project_setting/delete_project_dialog",
    ], {
        useSuspense: false
    })

    useEffect(() => {
        // i18n.changeLanguage(organization.platformLanguage);
    }, [])

    function handleDeleteName(e) {
        setDeleteName(e.target.value);
    }

    async function handleDelete() {
        setDeletingProject(true);
        await onDelete();
    }

    return (
        <Dialog
            width={"42%"}
            title={t("title")}
            onClose={toggleDialog}
        >
            <form onSubmit={(e) => e.preventDefault()}>
                <div className="mt-0 l-150 dialog-content">
                    <div className="pb-3 form-label">
                        {t("warning1")}
                    </div>
                    <p className="my-2">
                        {t("warning2")}
                    </p>
                    <p className="my-2">
                        {t("warning3")}
                    </p>
                    <p className="my-2">
                        {t("warning4")}
                        <span className='text-primary mx-1'>
                            <strong>{projectName}</strong>
                        </span>
                        {t("warning4end")}
                    </p>
                    <p>
                        <div className="mb-2">
                            <input
                                autoFocus={true}
                                onChange={handleDeleteName}
                                value={deleteName}
                                className="mt-2 form-control w-50"
                            />
                        </div>
                    </p>
                </div>
                <DialogActionsBar layout="end">
                    {deletingProject && (
                        <small className="mt-1">
                            <div className="d-inline-block">
                                <InnerLoader borderColor="red" />
                                <span className="me-4 text-danger"></span>
                            </div>
                        </small>
                    )}
                    <button
                        onClick={toggleDialog}
                        type="button"
                        className="mx-1 btn btn-secondary"
                    >
                        {t("buttons.cancel")}
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={handleDelete}
                        disabled={!(deleteName === projectName)}
                    >
                        {t("buttons.delete")}
                    </button>
                </DialogActionsBar>
            </form>
            {deletingProject && <OverlayLoader />}
        </Dialog>
    )
}

export default DeleteProjectDialog;